import { InjectionToken } from "@angular/core";
import { ProductIdentifierDto } from "../../INTEGRA_Shop_Client";
import { Observable } from "rxjs";

export interface IProductCompareService {
  compareListContainsProductIdentifier(productIdentifierDto: ProductIdentifierDto): boolean;

  productIdentifierListChangeGet(): Observable<ProductIdentifierDto[]>;

  productAdd(productIdentifier: ProductIdentifierDto): boolean;

  productListAdd(productIdentifierList: ProductIdentifierDto[]): boolean;

  productRemove(productIdentifier: ProductIdentifierDto): boolean;

  productListRemove(productIdentifierList: ProductIdentifierDto[]): boolean;

  productListSet(productIdentifierList: ProductIdentifierDto[]): void;

  productListClear(): void;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IProductCompareServiceToken = new InjectionToken<IProductCompareService>('IProductCompareServiceToken');
